import React from 'react';
import { useOutletContext } from 'react-router-dom';

import './less/index.less';
import { Content2DataSource, Content3DataSource, Content1DataSource } from './data.source';
import Content1 from './Content1';
import Content2 from './Content2';
import Content3 from './Content3';

export default function Test() {

  const { isMobile } = useOutletContext();

  const children = [
    <Content1
      id="Content1"
      key="Content1"
      dataSource={Content1DataSource}
      isMobile={isMobile}
    />,
    <Content2
      id="Content2"
      key="Content2"
      dataSource={Content2DataSource}
      isMobile={isMobile}
    />,
    <Content3
      id="Content3"
      key="Content3"
      dataSource={Content3DataSource}
      isMobile={isMobile}
    />
  ];
  return (
    <div
      className="templates-wrapper"
    >
      {children}
    </div>
  );
}
